import { Box, Input, Text, Grid, GridItem, Icon, Center } from '@chakra-ui/react';
import React, { useEffect, useMemo, useState } from 'react';
import { FaRegFileAlt } from 'react-icons/fa';
import { HiOutlineUpload, HiOutlineDownload } from 'react-icons/hi';
import { RiDeleteBin5Line } from 'react-icons/ri';

export const FileInput: React.FC<{
  onChangeFile: (formData: FormData | null) => void;
  fieldValue?: string | FormData | null;
  onResetFieldValue?: () => void;
}> = ({ onChangeFile, fieldValue, onResetFieldValue }) => {
  const [selectedFile, setSelectedFile] = useState<FileList | null>(null);
  const [filePath, setFilePath] = useState('');

  useEffect(() => {
    if (typeof fieldValue !== 'string') {
      if (selectedFile && selectedFile[0]) {
        const newFormData = new FormData();
        newFormData.append('datasheet', selectedFile[0], selectedFile[0].name);
        onChangeFile(newFormData);
      } else {
        onChangeFile(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFile]);

  const isSelectedFile = !!(selectedFile && selectedFile[0]);
  const FileComponent = useMemo(() => {
    if (typeof fieldValue === 'string')
      return (
        <>
          <GridItem>
            <Icon as={HiOutlineDownload} fontSize="20px" />
          </GridItem>
          <GridItem>
            <Grid gridTemplateRows="20px 20px" lineHeight="20px" fontSize="12px">
              <GridItem display="flex">Há um arquivo selecionado</GridItem>
              <GridItem display="flex">Clique para baixar</GridItem>
            </Grid>
          </GridItem>
        </>
      );
    if (isSelectedFile)
      return (
        <>
          <GridItem>
            <Icon as={FaRegFileAlt} fontSize="20px" />
          </GridItem>
          <GridItem>
            <Grid gridTemplateRows="20px 20px" lineHeight="20px" fontSize="12px">
              <GridItem display="flex">{selectedFile?.[0].name}</GridItem>
              <GridItem display="flex">{`${selectedFile?.[0].size} bytes`}</GridItem>
            </Grid>
          </GridItem>
        </>
      );
    return (
      <Center w="100%">
        <Text mr="1rem">Selecionar arquivo</Text>
        <HiOutlineUpload fontSize="20px" />
      </Center>
    );
  }, [isSelectedFile, selectedFile, fieldValue]);

  return (
    <Box w="100%" h="100%">
      <Grid
        w="100%"
        h="40px"
        border="1px solid"
        borderRadius="md"
        borderColor="gray.200"
        textAlign="center"
        lineHeight="40px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        color="gray.500"
        transition="all 0.3s"
        _hover={{ bg: 'gray.200' }}
        cursor="pointer"
        px="1rem"
      >
        <GridItem w="100%">
          <label htmlFor={typeof fieldValue === 'string' ? '' : 'contract-data-selectedFile'}>
            <Grid
              gridTemplateColumns={
                isSelectedFile || typeof fieldValue === 'string' ? '24px auto auto' : 'auto'
              }
              w="100%"
              columnGap="1rem"
              h="40px"
              cursor="pointer"
              onClick={() => {
                if (typeof fieldValue === 'string') window.open(fieldValue);
              }}
            >
              {FileComponent}
            </Grid>
          </label>
        </GridItem>
        {(isSelectedFile || typeof fieldValue === 'string') && (
          <GridItem display="flex" justifyContent="end" alignItems="center">
            <Icon
              as={RiDeleteBin5Line}
              fontSize="20px"
              color="error.400"
              transition="all 0.3s"
              onClick={() => {
                setSelectedFile(null);
                setFilePath('');
                if (onResetFieldValue && fieldValue && typeof fieldValue === 'string')
                  onResetFieldValue();
              }}
            />
          </GridItem>
        )}
      </Grid>
      <Input
        display="none"
        type="file"
        name="selectedFile"
        id="contract-data-selectedFile"
        placeholder="Selecionar arquivo"
        multiple
        onChange={({ target: { files, value } }) => {
          setFilePath(value);
          setSelectedFile(files);
        }}
        value={filePath}
      />
    </Box>
  );
};
